import { Component } from '@angular/core';
import {CommonService} from '../../../core/service/common.service';
import {MessageService} from '../../../core/service/message.service';
import {ChumonService} from '../../../core/service/chumon.service';
import {MasterService} from '../../../core/service/master.service';
import {MatDialogRef} from '@angular/material/dialog';
import {WasuuErrorStateMatcher} from '../../../core/error-state/wasuu-error-state-matcher';

@Component({
  selector: 'app-add-chumon-dialog',
  templateUrl: './add-chumon-dialog.component.html',
  styleUrls: ['./add-chumon-dialog.component.scss']
})
export class AddChumonDialogComponent {
  chumon = this.chumonService.genChumon();
  constructor(public commonService: CommonService,
              private messageService: MessageService,
              public masterService: MasterService,
              public chumonService: ChumonService,
              public wasuuErrorStateMatcher: WasuuErrorStateMatcher,
              public matDialogRef: MatDialogRef<AddChumonDialogComponent>) { }

  /**
   * 注文Docを登録
   * 正常に書き込めたらモーダルを閉じる
   */
  register() {
    this.chumonService.saveNewManualChumon(this.chumon).then(() => {
      this.messageService.pushInfo('登録しました');
      console.log('document successfully registered!');
      this.commonService.close(this.matDialogRef);
    }).catch(error => {
      this.messageService.pushError('登録に失敗しました');
      console.log(error);
    });
  }
}
